// extracted by mini-css-extract-plugin
export default {"active":"TabPanel_active__dxEir","inactive":"TabPanel_inactive__tRq0J"};